import React from "react";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import { DataPoints } from "./DataPoints";
import TableWithCustomSearch from "../../../../components/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";
import ReactTooltip from "react-tooltip";

export const SectionToggleWrapper = ({
  children,
  title,
  data,
  currencySymbol,
  idForConfigurator,
  wrappedColumns = ["Staff Name", "Product Name", "Revenue Category"],
  isLoading,
  fileName,
  ...restTableProps
}) => {
  const addTooltip = (header, formattedValue) =>
    wrappedColumns.includes(header) && formattedValue.length > 26 ? (
      <div className="wrapped-text" data-tip={formattedValue}>
        {formattedValue}
      </div>
    ) : (
      formattedValue
    );
  const content = () => {
    const rebuildTooltip = () => {
      setTimeout(() => {
        ReactTooltip.rebuild();
      }, 0);
    };

    return children ? (
      children
    ) : data?.tableInfo?.data?.length ? (
      <>
        {data?.dataPoints ? (
          <DataPoints dataPoints={data.dataPoints} currencySymbol={currencySymbol} />
        ) : null}
        <ReactTooltip effect="solid" />
        <TableWithCustomSearch
          data={data.tableInfo.data}
          colHeaders={data.tableInfo.colHeaders}
          columns={data.tableInfo.columns}
          rawDataLink={data?.rawDataLink}
          filterName={title}
          showCount={false}
          tableWrapperId="client-info"
          onFilteredItemsChange={rebuildTooltip}
          onPageChange={rebuildTooltip}
          fileName={fileName}
          customFn={(header, formattedValue) => addTooltip(header, formattedValue)}
          {...restTableProps}
        />
      </>
    ) : (
      <span className="error">No data</span>
    );
  };
  return (
    <span id={`${idForConfigurator}ModuleWrapper`} className="moduleWrapper">
      <SectionToggle autoHeight title={title} content={content()} isLoading={isLoading} />
    </span>
  );
};
